import { useMutation } from 'react-query';

import { AuthType } from '@portals/types';

import { AUTH_BASE_URL, authQueryKeys, AUTH_API_URL } from './auth.constants';
import { useApiQuery } from '../hooks';
import { ServerError } from '../types/common';
import { fetchApiRequest } from '../utils/common';

export function useGoogleSSOEnabled() {
  return useApiQuery<boolean>(
    `${AUTH_BASE_URL}/google/enabled`,
    authQueryKeys.google.enabled(),
    {
      staleTime: 0,
    }
  );
}

interface UseRegisterWithGoogleParams {
  token: string | undefined;
}

export function useRegisterWithGoogle() {
  return useMutation<AuthType, ServerError, UseRegisterWithGoogleParams>({
    mutationFn: ({ token }) =>
      fetchApiRequest(`${AUTH_API_URL}/google/register`, {
        method: 'POST',
        headers: new Headers({
          'Content-Type': 'application/json',
          cache: 'no-store',
        }),
        body: JSON.stringify({
          token,
          accepted_terms_and_conditions: true,
        }),
      }),
  });
}
